import React, { useState, useContext, useEffect } from 'react';
import AuthContext from 'store/AuthContext';
import { completeAmplifyLogin } from 'utils/completeAmplifyLogin';
import TextBox from 'components/formInputs/textBox/TextBox';
import FormHeaderLabel from './openKnotsLoginHelpers/FormHeaderLabel';
import FormButton from './openKnotsLoginHelpers/FormButton';
import { setLoginOrigin } from 'utils/loginOrigin';

const OpenKnotsOtpScreen = (props) => {
    const ctx = useContext(AuthContext);
    const [otp, setOtp] = useState();
    const [otpTypeError, setOtpTypeError] = useState(false);
    const [otpTypeErrorMsg, setOtpTypeErrorMsg] = useState();
    const [isOtpValid, setIsOtpValid] = useState(true);

    //resend otp
    const [isOtpResent, setIsOtpResent] = useState();
    const [showLoading, setShowLoading] = useState(false);

    //otp timer
    const [timer, setTimer] = useState(60);

    const handleOTP = (e) => {
        setIsOtpValid(true);
        setOtp(e.target.value);
        setOtpTypeErrorMsg();
        setOtp(e.target.value);
    };

    const handleOtpValidation = () => {
        if (!otp || otp === '') {
            setOtpTypeError(true);
            setOtpTypeErrorMsg('This field is required');
        } else {
            setShowLoading(true);
            ctx.amplifyAuth()
                .sendCustomChallengeAnswer(ctx.userObject, otp)
                .then(async (res) => {
                    if (res.username && res.signInUserSession) {
                        setLoginOrigin('openknots');
                        const result = completeAmplifyLogin(res, { onLogin: ctx.onLogin, defaultPath: '/dashboard?type=openKnots', });
                        if (!result.ok) {
                            ctx.amplifyAuth()
                                .signOut()
                                .catch(() => { });
                            setIsOtpValid(false);
                        }
                    } else {
                        setIsOtpValid(false);
                    }
                })
                .catch((error) => {
                    setIsOtpValid(false);
                })
                .finally(() => {
                    setShowLoading(false);
                });
        }
    };

    const handleResendOtp = async () => {
        setIsOtpValid(true);
        setTimer(60);

        setShowLoading(true);
        ctx.amplifyAuth()
            .signIn(props.email, props.password)
            .then((res) => {
                ctx.handleUserObject(res);
                setShowLoading(false);
                if (res) {
                    setIsOtpResent(true);
                } else {
                    setIsOtpResent(false);
                }
            })
            .catch((error) => {
                setIsOtpResent(false);
            })
            .finally(() => {
                setShowLoading(false);
            });
    };

    useEffect(() => {
        if (timer > 0) {
            const intervalId = setTimeout(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
            return () => clearTimeout(intervalId);
        }
    }, [timer]);

    return (
        <div className='opk-login-otp col-12 col-md-5 position-relative bg-white' id='loginInput'>
            <div className='d-md-flex justify-content-center align-items-center vh-100'>
                <div className='col-12 col-md-10 text-start w-100 d-flex flex-column justify-content-center align-items-center'>
                    <FormHeaderLabel UpperText="Enter OTP for Authentication" fs="22px" />
                    <p className='text-neutral-900 row w-100 opk-forgot-form-subheading'>
                        <span className='col-2 d-flex align-items-center justify-content-center ps-4'><img src='/images/openknots-otp-vector.svg' alt='OTP Vector' /></span>
                        <span className='col-10'>A verification code code has been sent to your registered phone number and email ID</span>
                    </p>
                    {!isOtpValid && (
                        <div
                            className='col-lg-10 alert rounded custom-error-box mt-3 mb-3 w-100 err-message err-message-background'
                            role='alert'>
                            <i className='bi bi-exclamation-circle-fill text-error-700 me-2'></i>
                            <span className='font-b2'>Invalid OTP</span>
                        </div>
                    )}
                    {isOtpResent && (
                        <div
                            className='col-lg-10 alert alert-success border border-success rounded custom-error-box mt-3 w-100'
                            role='alert'>
                            <i className='bi bi-check-circle-fill text-primary-700 me-2'></i>
                            <span className='text-black fw-600'>OTP sent Successfully</span>
                        </div>
                    )}
                    <div className='col-lg-10 mt-3 w-100'>
                        <TextBox
                            label='OTP'
                            type='number'
                            id='otp'
                            isHideArrow={true}
                            placeholder='Enter code here'
                            onChange={handleOTP}
                            error={otpTypeError}
                            errorMessage={otpTypeErrorMsg}
                            name='otp'
                            value={otp}
                        />


                    </div>
                    <div className='col-lg-10 mt-3 pt-1 w-100'>
                        <FormButton handleLogin={handleOtpValidation} showLoading={showLoading} Text='Verify' />
                    </div>
                    <div className='col-lg-10 w-100'>
                        <p className=' float-start text-light opk-login-lower-heading mt-1'>
                            Didn’t receive the code?{' '}
                            {timer > 0 ? <span className='text-white fw-bold fs-16 mt-2'>00 : {timer} sec</span> : <></>}
                        </p>
                        {timer > 0 ? (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a className=' float-end  text-light' disabled>
                                <span
                                    className='cursor-not-allowed text-secondary opk-login-lower-heading'
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}>
                                    Resend OTP
                                </span>
                            </a>
                        ) : (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a className=' float-end text-light '>
                                <span className='cursor text-light opk-login-lower-heading' onClick={handleResendOtp}>
                                    Resend OTP
                                </span>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpenKnotsOtpScreen;
